export default {"src":"/_next/static/media/coins-left.b8717dc1.svg","height":195,"width":116,"blurWidth":0,"blurHeight":0};